module.exports = __webpack_public_path__ + "static/media/twitter-grey.400eab42.svg";